function readLaunchQuery(): string {
    const [navigationEntry] = performance.getEntriesByType('navigation')
    try {
        return new URL(navigationEntry.name).search
    } catch {
        return location.search
    }
}

/** The affiliate `?tag=` the app was launched with; routing can rewrite the URL before the first page view. */
export const launchAssociateTag: string | undefined =
    new URLSearchParams(readLaunchQuery()).get('tag')?.trim() || undefined
